import type { Room } from 'livekit-client';
import { t } from 'i18next';
import { showSnackbar as dispatchSnackbar } from '@web-chat-core/ui-kit';
import type { ModerationCommand } from 'useCase/moderation/types';

const DEDUP_MS = 1000;

let lastWebinarSnackbarKey = '';
let lastWebinarSnackbarAt = 0;

/** Одноразовый skip snackbar при локальном toggle: metadata меняется раньше event и без moderatorSid. */
let skipWebinarModeNotificationForLocalInitiatorFlag = false;

/** Join в уже активный вебинар: metadata может прийти как undefined → true без toggle. */
let suppressWebinarEnableMetadataNotificationOnce = false;

export const skipWebinarModeNotificationForLocalInitiator = (): void => {
    skipWebinarModeNotificationForLocalInitiatorFlag = true;
};

export const consumeSkipWebinarModeNotificationForLocalInitiator = (): boolean => {
    if (!skipWebinarModeNotificationForLocalInitiatorFlag) {
        return false;
    }
    skipWebinarModeNotificationForLocalInitiatorFlag = false;
    return true;
};

export const suppressNextWebinarEnableMetadataNotification = (): void => {
    suppressWebinarEnableMetadataNotificationOnce = true;
};

export const consumeSuppressWebinarEnableMetadataNotification = (): boolean => {
    if (!suppressWebinarEnableMetadataNotificationOnce) {
        return false;
    }
    suppressWebinarEnableMetadataNotificationOnce = false;
    return true;
};

export const isLocalWebinarInitiator = (room: Room, cmd: ModerationCommand): boolean => {
    const local = room.localParticipant;
    if (cmd.moderatorSid != null && cmd.moderatorSid !== '' && local.sid === cmd.moderatorSid) {
        return true;
    }
    return cmd.moderatorIdentity != null && cmd.moderatorIdentity !== '' && local.identity === cmd.moderatorIdentity;
};

export const showWebinarModeSnackbar = (enabled: boolean, actorName: string): boolean => {
    const key = `${enabled}:${actorName}`;
    const now = Date.now();
    if (key === lastWebinarSnackbarKey && now - lastWebinarSnackbarAt < DEDUP_MS) {
        return false;
    }

    lastWebinarSnackbarKey = key;
    lastWebinarSnackbarAt = now;

    const message = enabled
        ? t('vks_webinar_enabled_by_user_tooltip', { '0': actorName })
        : t('vks_webinar_disabled_by_user_tooltip', { '0': actorName });
    dispatchSnackbar(message);
    return true;
};
